<div (keyup.arrowright)="activeModal.close('next')" (keyup.arrowleft)="activeModal.close('previous')" class="body">
    <div (click)="activeModal.dismiss('close-no-error'); (false)" class="mf-view-tools">
        <div class="d-flex justify-content-center my-2">
            <input class="d-none" />
            @if (navigationButtons) {
                <a
                    [openDelay]="300"
                    (click)="activeModal.close('previous'); (false)"
                    ngbTooltip="Prejšnji"
                    tooltipClass="d-none d-lg-block"
                    href="#"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-arrow-left"></i>
                </a>
            }
            @if (documentType === 'application/pdf' && !viewOnly) {
                <a
                    [openDelay]="300"
                    (click)="printFile(); $event.stopPropagation(); (false)"
                    ngbTooltip="Natisni dokument"
                    tooltipClass="d-none d-lg-block"
                    href="#"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-print"></i>
                </a>
            }
            <!-- @TODO: Ignored manually on 2023-09-15 -->
            <!-- eslint-disable @angular-eslint/template/eqeqeq -->
            @if (
                !(
                    documentType != 'application/pdf' &&
                    !documentType.includes('video') &&
                    documentType != 'text/plain' &&
                    !documentType.includes('image')
                ) && !viewOnly
            ) {
                <a
                    [openDelay]="300"
                    (click)="downloadFile(); $event.stopPropagation(); (false)"
                    ngbTooltip="Prenesi dokument"
                    tooltipClass="d-none d-lg-block"
                    href="#"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-download"></i>
                </a>
            }
            <!-- eslint-enable -->
            @if (documentType === 'application/pdf' || documentType.includes('image')) {
                <a
                    [openDelay]="300"
                    (click)="zoom_in(); $event.stopPropagation(); (false)"
                    href="#"
                    ngbTooltip="Povečaj"
                    tooltipClass="d-none d-lg-block"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-plus"></i>
                </a>
            }
            @if (documentType === 'application/pdf' || documentType.includes('image')) {
                <a
                    [openDelay]="300"
                    (click)="zoom_out(); $event.stopPropagation(); (false)"
                    href="#"
                    ngbTooltip="Pomanjšaj"
                    tooltipClass="d-none d-lg-block"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-minus"></i>
                </a>
            }
            @if (documentType === 'application/pdf' && !fullScreenEnabled) {
                <a
                    [openDelay]="300"
                    (click)="fullscreen(); $event.stopPropagation(); (false)"
                    href="#"
                    ngbTooltip="Razširi"
                    tooltipClass="d-none d-lg-block"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-expand"></i>
                </a>
            }
            @if (documentType === 'application/pdf' && fullScreenEnabled) {
                <a
                    [openDelay]="300"
                    (click)="fullscreen(); $event.stopPropagation(); (false)"
                    href="#"
                    ngbTooltip="Skrči"
                    tooltipClass="d-none d-lg-block"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-compress"></i>
                </a>
            }
            <a
                [openDelay]="300"
                (click)="activeModal.dismiss('close-no-error'); (false)"
                ngbTooltip="Zapri"
                tooltipClass="d-none d-lg-block"
                href="#"
                class="btn btn-primary py-1 px-2"
            >
                <i class="las la-times"></i>
            </a>
            @if (navigationButtons) {
                <a
                    [openDelay]="300"
                    (click)="activeModal.close('next'); (false)"
                    ngbTooltip="Naslednji"
                    tooltipClass="d-none d-lg-block"
                    href="#"
                    class="btn btn-primary py-1 px-2"
                >
                    <i class="las la-arrow-right"></i>
                </a>
            }

            <!-- <button
      class="btn btn-accent m-btn m-btn--icon m-btn--pill mt-2 mb-2 "
      *ngIf="signature?.appendTo"
      (click)="appendDocumentToCase()"
      >
      Pripni k avtorizaciji
    </button> -->
        </div>
    </div>

    <!-- IFRAME FOR PRINTING -->
    <iframe #blob frameborder="0" width="0px" height="0px" style="left: -9999px"></iframe>
    <!-- PDF -->
    @if (documentType === 'application/pdf') {
        <div (click)="clickEvent($event)" id="pdf" style="overflow: auto" class="test">
            @if (fileReady) {
                <pdf-viewer
                    #medaViewer
                    [src]="encryptedFile ? { url: documentFile | safe: 'url', password: password } : documentFile"
                    [fit-to-page]="true"
                    [original-size]="false"
                    [zoom]="zoom"
                    (after-load-complete)="stopLoading($event)"
                    (error)="showError($event)"
                    class="d-block position-static"
                ></pdf-viewer>
            }
        </div>
    }
    <!-- IMAGE -->
    @if (documentType.includes('image')) {
        <div (click)="clickEvent($event)" class="mf-image-view">
            <img [src]="documentFile | safe: 'url'" [ngStyle]="{ width: widthPic }" id="img" class="center" />
        </div>
    }
    <!-- ENCRYPTED PDF -->
    @if (failedPassword) {
        <div style="background-color: white; border-radius: 10px" class="text-warning text-center p-4 col-12 col-md-6 col-xl-3 ml-auto mr-auto mt-3">
            <div class="m-2">
                <span style="font-size: 150%" i18n="media.view.document.">Dokument je zaklenjen</span>
            </div>
            <div class="m-2">
                <span><i class="la la-lock la-5x"></i></span>
            </div>
            <div>
                <button (click)="reEnterPassword()" class="btn btn-accent m-btn m-btn--pill m-btn--custom m-btn--air">Vnesi geslo</button>
            </div>
        </div>
    }
    <!-- TEXT FILE-->
    <!-- @TODO: Ignored manually on 2023-09-15 -->
    <!-- eslint-disable @angular-eslint/template/eqeqeq -->
    @if (documentType == 'text/plain') {
        <div (click)="clickEvent($event)" class="mf-text-plain-view p-3 m-1">
            <p>
                {{ documentFile }}
            </p>
        </div>
    }
    <!-- eslint-enable -->
    <!-- VIDEO -->
    <!-- <video #videoPlayer controls preload="auto" class="center" [ngClass]="{ hideVideo: !documentType.includes('video') }">
<source src="documentFile | safe: 'url'" type="video/mp4" />
Vaš brskalnik ne podpira ogleda videa
</video> -->
    <!-- UNKNOWN TYPE -->
    <!-- @TODO: Ignored manually on 2023-09-15 -->
    <!-- eslint-disable @angular-eslint/template/eqeqeq, @angular-eslint/template/conditional-complexity -->
    @if (documentType != 'application/pdf' && !documentType.includes('video') && documentType != 'text/plain' && !documentType.includes('image')) {
        <div style="background-color: white; border-radius: 10px" class="text-center p-4 col-12 col-md-6 col-xl-3 mx-auto mt-3">
            <!-- eslint-enable -->
            <div class="row">
                <div class="col-12" i18n="@@media.view.unknown.document">Predogled ni mogoč</div>
                <div class="mt-2 mx-auto" i18n="@@media.view.download.document">
                    <button (click)="downloadFile()" class="btn btn-outline-accent m-btn m-btn--pill btn-block">Prenesi datoteko</button>
                </div>
            </div>
        </div>
    }
</div>
